import { render, staticRenderFns } from "./MTA.vue?vue&type=template&id=0c8a161e&"
import script from "./MTA.vue?vue&type=script&lang=js&"
export * from "./MTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports